import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/back-button.svg'


const _hoisted_1 = ["onclick"]


export default /*#__PURE__*/_defineComponent({
  __name: 'BackButton',
  props: {
    onclick: { type: Function }
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!

  return (_openBlock(), _createElementBlock("button", {
    class: "back-button",
    onclick: _ctx.onclick
  }, [
    _createVNode(_component_v_avatar, { size: "32px" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_img, {
          src: _imports_0,
          alt: "Voltar"
        })
      ]),
      _: 1
    })
  ], 8, _hoisted_1))
}
}

})